<template>
  <mp-modal size="xl" is-centered :is-open="isOpen" :on-close="handleClose">
    <mp-modal-content max-width="780px">
      <mp-modal-body p="10" pb="5">
        <mp-text align="center" font-size="2xl" font-weight="semibold" mb="6">{{ title }}</mp-text>
        <mp-text font-weight="semibold">
          What is the purpose of your cycle?
        </mp-text>

        <mp-flex gap="6" mt="4">
          <mp-box v-for="item in purposes" :key="item.value" class="adjustable-radio" flex="1 1 0" position="relative">
            <input :id="`cycle-purpose-${item.value}`" v-model="selectedPurpose" name="cycle_purpose" type="radio" :value="item.value" />
            <label :for="`cycle-purpose-${item.value}`" :set="(isChecked = selectedPurpose === item.value)" @click="onClickPurpose(item.value)">
              <mp-box p="6" align="center" cursor="pointer" border="1px" border-radius="md" :border-color="isChecked ? 'blue.500' : 'gray.100'">
                <mp-icon v-if="isNeedUpgrade(item.value)" name="upgrade" variant="fill" color="violet.400" position="absolute" top="2" right="2" />
                <mp-icon :name="item.icon" :variant="isChecked ? 'duotone' : 'outline'" width="56px!important" height="56px!important" mb="7" />
                <mp-box :font-weight="isChecked ? 'semibold' : 'normal'">{{ item.name }} review</mp-box>
              </mp-box>
            </label>
          </mp-box>
        </mp-flex>

        <mp-form-control :is-invalid="!!errorName" :is-disabled="isDisabledInput" mt="11">
          <mp-form-label align-items="center">
            Cycle name
            <mp-text color="gray.400" font-size="sm" font-weight="normal" ml="auto">{{ name.length }}/60</mp-text>
          </mp-form-label>
          <mp-input
            v-model="name"
            data-qa="modal-cycle-purpose-input-name"
            @keyup.enter="submit"
            @blur="$v.name.$touch"
            @change="errorMessage = ''"
          />
          <mp-form-error-message>
            {{ errorName }}
          </mp-form-error-message>
        </mp-form-control>

        <mp-flex mt="8" justify-content="flex-end">
          <mp-button data-qa="modal-cycle-purpose-btn-cancel" variant="ghost" margin-right="3" :is-disabled="isLoadingSubmit" @click="handleClose"
            >Cancel</mp-button
          >
          <mp-button
            data-qa="modal-cycle-purpose-btn-submit"
            :is-disabled="isLoadingSubmit || isDisabledInput"
            :is-loading="isLoadingSubmit"
            @click="submit"
            >{{ submitText }}</mp-button
          >
        </mp-flex>
      </mp-modal-body>
    </mp-modal-content>
    <mp-modal-overlay />
  </mp-modal>
</template>
<script>
import { maxLength, required } from 'vuelidate/lib/validators';
import { MpModal, MpModalBody, MpModalContent, MpModalOverlay } from '@mekari/pixel';

export default {
  name: 'ModalCyclePurpose',
  components: {
    MpModal,
    MpModalOverlay,
    MpModalContent,
    MpModalBody,
  },
  props: {
    isFirst: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    cycleName: {
      type: String,
      default: '',
    },
    cyclePurpose: {
      type: String,
      default: 'performance',
    },
  },
  data() {
    return {
      isOpen: false,
      isLoadingSubmit: false,
      selectedPurpose: '',
      name: '',
      errorMessage: '',
    };
  },
  validations: {
    name: { required, maxLength: maxLength(60) },
  },
  computed: {
    title() {
      return this.isFirst ? 'Create your first cycle' : 'Create your cycle';
    },
    purposes() {
      return this.$store.state.review.cyclePurposes;
    },
    errorName() {
      let error = this.errorMessage;
      if (this.$v.name.$error) {
        if (!this.$v.name.required) error = 'This field is required';
        if (!this.$v.name.maxLength) error = `Cycle name must have at most ${this.$v.name.$params.maxLength.max} characters.`;
      }
      return error;
    },
    submitText() {
      return this.isEdit ? 'Save' : 'Create';
    },
    canAccessSuccessionPlan() {
      return this.$store.state.canAccessSuccessionPlan || false;
    },
    isDisabledInput() {
      return !this.canAccessSuccessionPlan && this.selectedPurpose === 'competency';
    },
  },
  methods: {
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        try {
          this.isLoadingSubmit = true;
          const { valid, message } = await this.$store.dispatch('review/validateCycleName', { name: this.name });

          if (valid) {
            this.$router.push({ name: 'review_cycle_create', query: { name: this.name, purpose: this.selectedPurpose } });
            this.handleClose();
          } else {
            this.errorMessage = message;
          }
        } catch (err) {
          this.alertToast(err.message || 'Failed to create cycle name', 'danger');
        } finally {
          this.isLoadingSubmit = false;
        }
      }
    },
    handleOpen() {
      this.isOpen = true;
      this.$v.$reset();
      this.errorMessage = '';

      this.selectedPurpose = this.cyclePurpose;
      this.name = this.cycleName;
    },
    handleClose() {
      this.isOpen = false;
    },
    isNeedUpgrade(purpose) {
      return purpose === 'competency' && !this.canAccessSuccessionPlan;
    },
    onClickPurpose(purpose) {
      if (this.isNeedUpgrade(purpose)) {
        const route = this.$router.resolve({ name: 'talent_management_landing' });
        window.open(route.href, '_blank');
      }
    },
  },
};
</script>
